<template>
    <div class="products-listing--box">
        <a :href="product.url" class="products-listing--box--cover" @click="trackClick">
            <ProductImage :product="product" />
        </a>

        <div class="products-listing--box--content">
            <div class="product-info">
                <div class="product-info--head">
                    <a :href="product.url" class="product-info--head--title">
                        <span v-if="data.product_state_title" class="flag" :class="data.product_state_flag">
                            {{ data.product_state_title }}:
                        </span>

                        {{ product.title }}
                    </a>

                    <p v-if="data.subtitle" class="product-info--head--description">
                        {{ data.subtitle }}
                    </p>

                    <div class="product-info--head--authors">
                        <a :href="author.url" v-for="author in data.authors" :key="author.id">
                            {{ author.name }}
                        </a>
                    </div>
                </div>

                <div class="product-info--tags">
                    <div v-if="data.average_rating >= 4" class="product-info--tags--item">
                        <div class="rating-result">
                            {{ data.average_rating_formatted }}
                        </div>
                    </div>

                    <div v-if="product.tags" v-for="(tag, index) in product.tags" :key="index" class="product-info--tags--item">
                        <span class="flag" :class="tag.class">{{ tag.title }}</span>
                    </div>
                </div>

                <div class="product-info--description">
                    <span v-html="data.short_description"></span> <a :href="`${product.url}#viac-o-knihe`" class="btn-show-more">Viac o knihe</a>
                </div>

                <div class="product-info--footer">
                    <div class="product-info--footer--box">
                        <div class="product-price-box inline medium">
                            <h3>
                                <small v-if="product.final_discount_value">{{ product.price_with_tax_formatted }}​​​​​​​</small>
                                {{ product.final_price_formatted }}
                            </h3>
                            <span v-if="product.final_discount_value" class="discount-tag discount-tag-medium">
                                {{ product.final_discount_value }}
                            </span>
                        </div>
                    </div>

                    <div v-if="product.product_type_id === 5" class="product-info--footer--box">
                        <a :href="product.url" class="btn btn-action-red btn-add-to-cart btn-add-to-cart-sm">Pridať do košíka</a>
                    </div>

                    <div v-if="product.product_type_id !== 5" class="product-info--footer--box">
                        <span v-if="!product.can_be_sold" class="btn btn-action-red disabled btn-add-to-cart btn-add-to-cart-sm">Pridať do košíka</span>
                        <span v-else class="btn btn-action-red btn-add-to-cart btn-add-to-cart-sm" data-btn="add-to-cart" :data-product-id="product.id" :data-user-id="user_id" :data-product="product" :data-list-name="'listing'">Pridať do košíka</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductImage from './ProductImage'

    export default {
        components: {
            ProductImage
        },
        props: {
            product: {
                type: Object
            },
            shopOptions: {
                type: Object
            },
            user_id: {
                type: Number
            },
            index: {
                type: Number
            }
        },
        computed: {
            data() {
                let data = {
                    product_state_flag: this.product.product_state ? this.product.product_state.flag : null,
                    product_state_title: this.product.product_state ? this.product.product_state.title : null,
                    subtitle: this.product.subtitle,
                    authors: this.product.authors,
                    average_rating: this.product.average_rating,
                    average_rating_formatted: this.product.average_rating_formatted,
                    short_description: this.product.short_description,
                }

                if ( [2].includes( this.product.product_type_id ) ) data = {
                    product_state_flag: 'flag-red',
                    product_state_title: this.product.product_type.name,
                    subtitle: null,
                    authors: this.mergeAuthors( this.product ),
                    average_rating: null,
                    average_rating_formatted: null,
                    short_description: this.product.short_description,
                }

                if ( [3, 4].includes( this.product.product_type_id ) ) data = {
                    product_state_flag: 'flag-red',
                    product_state_title: this.product.product_type.name,
                    subtitle: this.product.bundles[0].subtitle,
                    authors: this.product.bundles[0].authors,
                    average_rating: this.product.bundles[0].average_rating,
                    average_rating_formatted: this.product.bundles[0].average_rating_formatted,
                    short_description: this.product.bundles[0].short_description,
                }

                return data
            }
        },
        methods: {
            trackClick() {
                if (window.AnalyticScripts && window.AnalyticScripts.trackProductClick) {
                    window.AnalyticScripts.trackProductClick(this.product, 'listing', this.index + 1);
                } else {
                    console.error('Tracking script not loaded');
                }            },
        }
    }
</script>
